
import { Vue, Options } from "vue-class-component";
import SearchSttScanComponent from "./Scan.vue";
import ScanFilterComponent from "./ScanFilter.vue";
import Table from "./table.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import {
  SearchSttList,
  SearchSttListSummary,
  SearchSttListSummaryDetail,
  SearchSttScan
} from "@/domain/entities/ListCariSTT";
import Print from "../modules/print.vue";
import { ListCariSTTController } from "@/app/ui/controllers/ListCariSTTController";
import { SearchSttFilter } from "@/data/payload/api/CariSttApiRequest";

@Options({
  components: {
    SearchSttScanComponent,
    ScanFilterComponent,
    Table,
    Print
  }
})
class CariSttScan extends Vue {
  goBack() {
    this.$router.push('/cari-stt')
  }

  mounted() {
    this.getSearchSttScanList();
  }

  async onProcessManifest() {
    try {
      MainAppController.closeErrorMessage();
      MainAppController.showLoading();
      const res = await ListCariSTTController.searchSttManifest();

      (this.$refs as any)["search-stt-scan-print"]?.printManifest(res);

      this.getSearchSttScanList();
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          this.$t("cariStt.errorProcessManifest"),
          this.onProcessManifest
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  get latestSttData(): SearchSttScan {
    if (this.dataTable.data.length) {
      return this.dataTable.data[0];
    }

    return new SearchSttScan();
  }

  dataTable = new SearchSttList();
  async getSearchSttScanList(params = new SearchSttFilter()) {
    try {
      MainAppController.closeErrorMessage();
      MainAppController.showLoading();
      this.dataTable = await ListCariSTTController.getSearchSttScanList(params);
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          this.$t("cariStt.errorFetchList"),
          this.getSearchSttScanList
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
  onSuccessScan(item: SearchSttScan) {
    this.dataTable.data.unshift(item);

    this.onCalculateSummary();
  }
  onCalculateSummary() {
    const hangingData = this.dataTable.data.filter(
      (item: SearchSttScan) => item.status?.toLowerCase() === "hanging"
    );

    const nonHangingData = this.dataTable.data.filter(
      (item: SearchSttScan) => item.status?.toLowerCase() === "non_hanging"
    );

    this.dataTable.summary = new SearchSttListSummary({
      hanging: new SearchSttListSummaryDetail({
        totalStt: hangingData.length,
        totalPieces: hangingData.reduce((a, b) => a + b.pieces, 0)
      }),
      nonHanging: new SearchSttListSummaryDetail({
        totalStt: nonHangingData.length,
        totalPieces: nonHangingData.reduce((a, b) => a + b.pieces, 0)
      })
    });
  }

  get isSidebarAndBreadcrumbV2() {
    return MainAppController.isSidebarAndBreadcrumbV2;
  }
}
export default CariSttScan;
